import React from "react";
import { type AnySchema, reach } from "yup";
import ValidationContext from "./validation-context";

// Gets the schema of a field from the Yup validation schema provided by ValidationContext
// If `resolvedAt` is present in the context, strip that prefix from the name
export function useFieldSchema(name: string): AnySchema {
  const validationContext = React.useContext(ValidationContext);

  return React.useMemo(() => {
    if (!validationContext?.validationSchema) {
      return undefined;
    }

    const resolvedLazyField = validationContext.resolvedFields?.[name];
    if (resolvedLazyField) {
      return resolvedLazyField;
    }

    const { validationSchema, resolvedAt } = validationContext;

    const actualName = resolvedAt
      ? name.substring(resolvedAt.length + 1)
      : name;

    try {
      return reach(validationSchema, actualName, undefined, undefined);
    } catch (_e) {
      // Not all fields have validation
      return undefined;
    }
  }, [validationContext, name]);
}
